import { PayloadAction, createSlice } from 'ngrx-slice';

import { AdvertisementBanner } from '@app/api/marketplace/models';

export interface State {
  adBanners: Array<AdvertisementBanner>;
}

export const initialState: State = {
  adBanners: [],
};

export const {
  actions: AdBannerActions,
  selectors,
  ...AdBannerFeature
} = createSlice({
  name: 'adBanner',
  initialState,
  reducers: {
    loadAdBanners: {
      trigger: (state) => {
        state.adBanners = [];
      },
      success: (
        state,
        action: PayloadAction<{ response: Array<AdvertisementBanner> }>
      ) => {
        state.adBanners = action.response;
      },
    },
    reset: (_) => initialState,
  },
});

export const AdBannerSelectors = {
  ...selectors,
};
